import axios from 'axios';
import { config } from '@/config';

const instance = axios.create({
  baseURL: config.WHMCS_URL,
  headers: {
    brand: config.COUNTRY,
    'Content-Type': 'application/json',
  },
});

const get = ({
  url, headers, cancelToken,
}) => instance.get(url, { headers, cancelToken });

const useDelete = ({
  url, headers, cancelToken,
}) => instance.delete(url, { headers, cancelToken });

const post = ({
  url, headers, data, cancelToken,
}) => instance.post(url, data, { headers, cancelToken });

const put = ({
  url, headers, data, cancelToken,
}) => instance.put(url, data, { headers, cancelToken });

const patch = ({
  url, headers, data, cancelToken,
}) => instance.patch(url, data, { headers, cancelToken });

const whmcs = {
  instance,
  get,
  post,
  put,
  useDelete,
  patch,
};

export default whmcs;
